var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.251 181.1c3.141-3.4 7.439-6 11.749-6 3.891 0 7.781 1.406 10.86 4.25l197.1 181.1 197.1-181.1c6.5-6 16.64-5.625 22.61.906 6 6.5 5.594 16.59-.89 22.59l-208 192a15.956 15.956 0 0 1-21.72 0l-208-192C-1.344 197.7-1.75 187.6 4.25 181.1"
  })));
};
export default SvgChevronDown;